import { render, staticRenderFns } from "./shipping-quote-request-form.vue?vue&type=template&id=84d23110&scoped=true&lang=pug&"
import script from "./shipping-quote-request-form.vue?vue&type=script&lang=ts&"
export * from "./shipping-quote-request-form.vue?vue&type=script&lang=ts&"
import style0 from "./shipping-quote-request-form.vue?vue&type=style&index=0&id=84d23110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d23110",
  null
  
)

export default component.exports